export class StateAtLeastOneTrue {
  constructor(initialState = true) {
    this.state = initialState
  }

  private TAG = 'StateAtLeastOneTrue'
  private state: boolean
  private participants: Set<string> = new Set<string>()

  setState(tag: string, state: boolean) {
    if (state) this.participants.add(tag)
    if (!state) this.participants.delete(tag)

    this.state = !!this.participants.size

    console.log(this.TAG, 'setState, remaining participants', this.participants, 'currentState', this.state)
  }

  getState() {
    return this.state
  }
}
